import { Button } from "react-bootstrap";

export default function CustomButton({ type, text, otherProps }) {
    return (
        <>
            <Button {...otherProps} className={`custom-button ${type}`}>{text}</Button>
        </>
    )
}